/**
 * Formatação monetária BRL com centavos sempre visíveis.
 */

export function formatCurrencyBRL(value) {
  const num = typeof value === 'number' ? value : parseFloat(value)
  const safe = Number.isFinite(num) ? num : 0

  return new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  }).format(safe)
}
